import { pathToRegexp } from 'path-to-regexp';
import routes from '../../constants/routes.external.json';
import { isProduction } from '../index';

export const routeMatches = (referer: string, type: 'callcenter' | 'restore' | 'cardsRestore') => {
    try {
        const url = new URL(referer);
        const path = `${url.pathname}${url.pathname.slice(-1) !== '/' ? '/' : ''}`;
        for (const route of routes[type]) {
            const { regexp } = pathToRegexp(route);
            if (path.match(regexp)) {
                return true;
            }
        }
        return false;
    } catch (e) {
        return false;
    }
};

export const isReqFromCallCenterPage = (referer = '') => routeMatches(referer, 'callcenter');

export const isReqFromWlPage = (referer = '') => {
    return ['karty/wl', 'karty/whitelable', 'kredit/whitelable', 'kredit/wl'].some((wlUrl) => referer.includes(wlUrl));
};

export const isReqFromWaybackPage = (referer = '') => {
    return ['/kredity/wayback/'].some((wlUrl) => referer.includes(wlUrl));
};

export const isReqFromRestorePage = (referer = '') =>
    routeMatches(referer, 'restore') || routeMatches(referer, 'cardsRestore');

/** Временно. Safari отправляет referer = "www.sravni.ru" для любых разделов сайта  */
export const isReqFromSravniRu = (referer = '') => {
    return isProduction ? /^(https:\/\/)?(www\.)?sravni\.ru/.test(referer) : true;
};

export const isSafari = (userAgent: string) => {
    return userAgent.includes('Safari') && !userAgent.includes('Chrome') && !userAgent.includes('Chromium');
};

export const projectRoot = process.cwd();
